import { enUS } from 'date-fns/locale'

export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2000
export const LONG_ALERT_TIME_MS = 10000
export const REVEAL_TIME_MS = 350
export const WELCOME_INFO_MODAL_MS = 350
export const DISCOURAGE_INAPP_BROWSERS = true
export const ENABLE_MIGRATE_STATS = true
export const BLOWFISH_KEY = 't4B@Lrkq#{EuF4%@LnxFQu@jZr!4p#'
export const BLOWFISH_IV = 'oN#bX&({'
export const ENABLE_ARCHIVED_GAMES = true
export const DATE_LOCALE = enUS
